import { LocalTypes } from '../types/ActionSpeedDial';

export default {
    namespaced: true,
    state: {
        open: false,
    },
    getters: {},
    actions: {},
    mutations: {
        [LocalTypes.mutations.SET_OPEN]: (state, open) => {
            state.open = open;
        },
    },
};
